import styled from 'styled-components';

export const DiscTxt = styled.div`
    font-wight: bold;
    font-size: 13px;
`
